import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_product_item = _resolveComponent("product-item")!

  return (_openBlock(), _createBlock(_TransitionGroup, {
    name: "list",
    tag: "div",
    class: "product-list"
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.products, (product) => {
        return (_openBlock(), _createBlock(_component_product_item, {
          product: product,
          key: product.id
        }, null, 8, ["product"]))
      }), 128))
    ]),
    _: 1
  }))
}